import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AttendancesPageContextProvider } from './attendances_page_context';
import BatchDrawer from './components/batch_drawer';
import BatchToolbar from './components/batch_toolbar';
import AttendancesPage from './page';

const AttendancesLayout = () => (
  <AttendancesPageContextProvider>
    <Box display="flex" flex={1} flexDirection="column" overflow="hidden">
      <AttendancesPage />

      <BatchToolbar />
      <BatchDrawer />

      <Outlet />
    </Box>
  </AttendancesPageContextProvider>
);

export default AttendancesLayout;
